/**
 * Created by Administrator on 2018/8/3 0003.
 */

import axios from 'axios'
import {Message} from 'element-ui'

let $router = null;
// let baseURL = 'http://localhost:30002'
// let baseURL = 'http://192.168.0.123:3000'
let baseURL = 'http://116.255.243.162:3002'
// 需要token的请求
// axios.defaults.baseURL = baseURL;
// const axiosTokenInstance = axios;
const axiosTokenInstance = axios.create({
  baseURL,
  withCredentials: true
});

axiosTokenInstance.init = (router) => {
  $router = router
};
// 添加请求拦截器
axiosTokenInstance.interceptors.request.use(config => {
    // 为实例添加token
    let token = localStorage.getItem('token') || "";
    if (!token) {
      Message({
        // showClose: true,
        message: "先に登録してくださいね~",
        type: 'error',
        duration: 1000
      });
      localStorage.clear();
      setTimeout(() => {
        $router.push({
          path: '/login'
        });
      }, 1000);
      // return Promise.reject("先に登録してくださいね~")
      
    } else {
      config.headers.common['Authorization'] = 'Bearer ' + token
      return config
    }

// Bearer是JWT的认证头部信息

  },
  error => {
    return Promise.reject(error)
  }
);

// 添加响应拦截
axiosTokenInstance.interceptors.response.use(
  response => {
    // console.log("response.data");
    // console.log(response.data);
    if (response.data.code === 0) {
      Message.error(response.data.message);    //有待验证
      return;
    }

    if (response.data.code >= 11 && response.data.code <= 14) {
      Message.error(response.data.message);    //用户认证失败
      localStorage.clear();
      setTimeout(() => {
        $router.push({
          path: '/login'
        });
      }, 1000);
      return;
    }

    if (response.data.code === 1) {
      return response.data;
    } else {
      const msg = response.data;
      return Promise.reject(msg);
    }
  },
  error => {
    // console.log("token报错：")
    // console.log(error);
    localStorage.clear('token');
    localStorage.clear('headImg');
    Message({
      message: "登録状態が無効なので、再登録してください~",
      type: 'error',
      duration: 2000
    });

    return Promise.reject(error)
  }
)

// 不需要token的请求
// const axiosInstance = axios
const axiosInstance = axios.create({
  baseURL,
  withCredentials: true,
  crossDomain: true
})

axiosInstance.interceptors.response.use(
  response => {
    if (response.data.code === 1) {
      return response.data;
    } else {
      const msg = response.data;
      return Promise.reject(msg)
    }
    // return response.data
  },
  error => {
    return Promise.reject(error)
  }
);

export {axiosTokenInstance, axiosInstance}



// WEBPACK FOOTER //
// ./src/api/axios.js